import { tierFactFirstAPI } from "./api";

export const getResidents = async () => {
  try {
    const res = await tierFactFirstAPI.getResidents();
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getBlocks = async (resident_id) => {
  try {
    if (!resident_id) return [];
    const res = await tierFactFirstAPI.getBlocks(resident_id);
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getWorkGroups = async (block_id) => {
  try {
    if (!block_id) return [];
    const res = await tierFactFirstAPI.getWorkGroups(block_id);
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

// Функция для генерации диапазона дат для полумесяца
export const generateDateRange = (year, month, half) => {
  const dates = [];
  const today = new Date();
  const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  
  let startDay, endDay;
  
  if (half === 'first') {
    // Первая половина: 1-15
    startDay = 1;
    endDay = 15;
  } else {
    // Вторая половина: 16-конец месяца
    startDay = 16;
    // Последний день месяца
    const lastDay = new Date(year, month, 0).getDate();
    endDay = lastDay;
  }
  
  // Генерируем даты для диапазона
  for (let day = startDay; day <= endDay; day++) {
    const date = new Date(year, month - 1, day);
    const yearStr = date.getFullYear();
    const monthStr = String(date.getMonth() + 1).padStart(2, '0');
    const dayStr = String(date.getDate()).padStart(2, '0');
    const isoDate = `${yearStr}-${monthStr}-${dayStr}`;
    
    dates.push({
      isoDate: isoDate,
      displayDate: `${dayStr}.${monthStr}.${yearStr}`,
      dayOfMonth: parseInt(dayStr),
      isToday: isoDate === todayStr
    });
  }
  
  return dates;
};

// Возвращает границы выбранного полумесяца в ISO формате (YYYY-MM-DD)
export const getHalfMonthRangeISO = (year, month, half) => {
  let startDay, endDay;

  if (half === 'first') {
    startDay = 1;
    endDay = 15;
  } else {
    startDay = 16;
    endDay = new Date(year, month, 0).getDate();
  }

  const startDate = new Date(year, month - 1, startDay);
  const endDate = new Date(year, month - 1, endDay);

  const toISO = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${dd}`;
  };

  return { date_start: toISO(startDate), date_end: toISO(endDate) };
};

// По дате (YYYY-MM-DD, DD.MM.YYYY или ISO с временем) возвращает { year, month, half } — полумесяц, в который попадает дата
export const getHalfMonthFromDate = (dateStr) => {
  if (!dateStr) return null;
  const s = String(dateStr).trim();
  let isoDate = s;
  if (s.match(/^\d{1,2}\.\d{1,2}\.\d{4}$/)) {
    const p = s.split('.');
    isoDate = `${p[2]}-${p[1].padStart(2, '0')}-${p[0].padStart(2, '0')}`;
  } else if (s.length >= 10 && s.slice(0, 10).match(/^\d{4}-\d{2}-\d{2}$/)) {
    isoDate = s.slice(0, 10);
  }
  if (!isoDate.match(/^\d{4}-\d{2}-\d{2}$/)) return null;
  const d = new Date(isoDate + 'T12:00:00');
  const year = d.getFullYear();
  const month = d.getMonth() + 1;
  const day = d.getDate();
  const half = day <= 15 ? 'first' : 'second';
  return { year, month, half };
};

// Функция для определения текущего полумесяца
export const getCurrentHalfMonth = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1; // 1-12
  const day = today.getDate();
  
  const half = day <= 15 ? 'first' : 'second';
  
  return { year, month, half };
};

// Функция для получения следующего полумесяца
export const getNextHalfMonth = (year, month, half) => {
  if (half === 'first') {
    // С первой половины переходим на вторую того же месяца
    return { year, month, half: 'second' };
  } else {
    // Со второй половины переходим на первую следующего месяца
    if (month === 12) {
      // Переход на январь следующего года
      return { year: year + 1, month: 1, half: 'first' };
    } else {
      return { year, month: month + 1, half: 'first' };
    }
  }
};

// Функция для получения предыдущего полумесяца
export const getPreviousHalfMonth = (year, month, half) => {
  if (half === 'second') {
    // Со второй половины переходим на первую того же месяца
    return { year, month, half: 'first' };
  } else {
    // С первой половины переходим на вторую предыдущего месяца
    if (month === 1) {
      // Переход на декабрь предыдущего года
      return { year: year - 1, month: 12, half: 'second' };
    } else {
      return { year, month: month - 1, half: 'second' };
    }
  }
};

// Функция для форматирования даты из DD.MM.YYYY в YYYY-MM-DD
export const formatDateToISO = (dateStr) => {
  if (!dateStr) return null;
  
  // Если уже в формате YYYY-MM-DD
  if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
    return dateStr;
  }

  // Если пришла дата-время (ISO), приводим к локальной дате YYYY-MM-DD
  if (typeof dateStr === 'string' && dateStr.includes('T')) {
    const d = new Date(dateStr);
    if (!isNaN(d.getTime())) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    }
  }
  
  // Если в формате DD.MM.YYYY
  if (dateStr.match(/^\d{1,2}\.\d{1,2}\.\d{4}$/)) {
    const parts = dateStr.split('.');
    const dd = String(parts[0]).padStart(2, '0');
    const mm = String(parts[1]).padStart(2, '0');
    return `${parts[2]}-${mm}-${dd}`;
  }
  
  return null;
};

export const getTimelineData = async (work_group_id, year, month, half) => {
  try {
    if (!work_group_id) {
      return { tasks: [], planFactData: [], matrix: [], dates: [], laborData: [] };
    }
    
    const today = new Date();
    const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    const halfRange = getHalfMonthRangeISO(year, month, half);

    const toDisplay = (isoDate) => {
      const y = isoDate.slice(0, 4);
      const m = isoDate.slice(5, 7);
      const d = isoDate.slice(8, 10);
      return `${d}.${m}.${y}`;
    };
    
    // Получаем задачи
    const tasksRes = await tierFactFirstAPI.getTimelineTasks(work_group_id);
    const tasks = tasksRes?.data || [];
    
    // Получаем даты из calc_tab
    const calcDatesRes = await tierFactFirstAPI.getCalcDates(work_group_id, halfRange.date_start, halfRange.date_end);
    const calcDates = calcDatesRes?.data || [];
    
    // Получаем план-факт данные (из plan_tab, fact_tab и calc_tab)
    const planFactRes = await tierFactFirstAPI.getPlanFact(work_group_id, halfRange.date_start, halfRange.date_end);
    const planFactData = planFactRes?.data || [];

    // Строим даты из calc_level_tab
    let dates = [];
    
    calcDates.forEach(item => {
      const isoDate = formatDateToISO(item.work_date);
      if (!isoDate) return;
      
      // Используем work_task_calc_level_id как ключ (уникален для каждого логического дня)
      const key = `level_${item.work_task_calc_level_id}`;
      
      dates.push({
        colKey: key,
        work_task_calc_level_id: item.work_task_calc_level_id,
        isoDate: isoDate,
        originalIsoDate: isoDate,
        displayDate: toDisplay(isoDate),
        dayOfMonth: parseInt(isoDate.slice(8, 10), 10),
        isToday: isoDate === todayStr,
        work_group_level_id: item.work_group_level_id,
        fact_date: isoDate,
        level_num: item.level_num,
        floor_order: item.floor_order,
        day_no: item.day_no,
        is_extra_day: item.is_extra_day,
        behind_days: item.behind_days,
        ahead_days: item.ahead_days,
        shift_days: item.shift_days,
        is_frozen: item.is_frozen,
      });
    });

    // Сортируем по floor_order, затем по day_no
    dates.sort((a, b) => {
      const orderA = a.floor_order !== null && a.floor_order !== undefined ? a.floor_order : 999999;
      const orderB = b.floor_order !== null && b.floor_order !== undefined ? b.floor_order : 999999;
      if (orderA !== orderB) return orderA - orderB;
      // Внутри этажа сортируем по day_no
      return (a.day_no || 0) - (b.day_no || 0);
    });

    if (!dates || dates.length === 0) {
      return { tasks: [], planFactData: [], matrix: [], dates: [], laborData: [] };
    }
    
    // Получаем данные о выходе людей
    const laborRes = await tierFactFirstAPI.getLaborPlan(work_group_id);
    const laborData = laborRes?.data || [];
    
    // Создаем словарь данных из calc_tab по task_dict_id и work_task_calc_level_id
    const planFactMap = {};
    planFactData.forEach(item => {
      // Ключ: task_dict_id + work_task_calc_level_id (уникальный логический день)
      const key = `${item.task_dict_id}_level_${item.work_task_calc_level_id}`;

      planFactMap[key] = {
        // Данные из calc_tab
        work_task_calc_id: item.work_task_calc_id,
        work_task_calc_level_id: item.work_task_calc_level_id,
        work_group_level_id: item.work_group_level_id,
        task_dict_id: item.task_dict_id,
        day_no: item.day_no,
        plan_value: item.plan_value,
        plan_closed_value: item.plan_closed_value,
        fact_used_value: item.fact_used_value,
        debt_in_value: item.debt_in_value,
        debt_closed_value: item.debt_closed_value,
        debt_out_value: item.debt_out_value,
        reserve_in_value: item.reserve_in_value,
        reserve_out_value: item.reserve_out_value,
        behind_days: item.behind_days,
        ahead_days: item.ahead_days,
        is_extra_day: item.is_extra_day,
        // Данные о факте (для редактирования)
        work_task_fact_id: item.work_task_fact_id,
        fact_value: item.fact_entered_value,  // введённый пользователем факт
        reason_id: item.reason_id,
        reason_name: item.reason_name,
      };
    });
    
    // Создаем словарь данных о людях по датам
    const laborMap = {};
    laborData.forEach(item => {
      const isoDate = formatDateToISO(item.labor_date);
      if (isoDate) {
        laborMap[isoDate] = {
          labor_plan_fact_id: item.labor_plan_fact_id,
          plan_people: item.plan_people,
          fact_people: item.fact_people
        };
      }
    });
    
    // Создаем строку "Выход людей"
    const laborRow = {
      task_dict_id: null,
      task_name: 'Выход людей',
      unit_id: null,
      unit_name: 'Люди',
      is_labor: true
    };
    
    // Для каждой колонки добавляем данные о людях (по дате)
    dates.forEach(dateInfo => {
      laborRow[dateInfo.colKey] = laborMap[dateInfo.isoDate] ? {
        ...laborMap[dateInfo.isoDate],
        plan_value: laborMap[dateInfo.isoDate].plan_people,
        fact_value: laborMap[dateInfo.isoDate].fact_people
      } : null;
    });
    
    // Создаем матрицу: задачи по вертикали, даты по горизонтали
    const taskMatrix = tasks.map(task => {
      const row = {
        task_dict_id: task.task_dict_id,
        task_name: task.task_name,
        unit_id: task.unit_id,
        unit_name: task.unit_name
      };
      
      // Для каждой колонки добавляем данные план-факт
      dates.forEach(dateInfo => {
        // Ключ: task_dict_id + colKey (который содержит work_task_calc_level_id)
        const key = `${task.task_dict_id}_${dateInfo.colKey}`;
        row[dateInfo.colKey] = planFactMap[key] || null;
      });
      
      return row;
    });
    
    // Строка "Выход людей" идет первой
    const matrix = [laborRow, ...taskMatrix];
    
    return {
      tasks,
      planFactData,
      matrix,
      dates,
      laborData
    };
  } catch (e) {
    console.error('Error in getTimelineData:', e);
    return { tasks: [], planFactData: [], matrix: [], dates: [], laborData: [] };
  }
};

export const getReasons = async () => {
  try {
    const res = await tierFactFirstAPI.getReasons();
    return res?.data || [];
  } catch (e) {
    return [];
  }
};

export const getLaborPlan = async (work_group_id) => {
  try {
    if (!work_group_id) return [];
    const res = await tierFactFirstAPI.getLaborPlan(work_group_id);
    return res?.data || [];
  } catch (e) {
    console.error('Error in getLaborPlan:', e);
    return [];
  }
};

export const saveFact = async (data) => {
  return await tierFactFirstAPI.saveFact(data);
};

export const deleteFact = async (data) => {
  return await tierFactFirstAPI.deleteFact(data);
};

export const saveLaborFact = async (data) => {
  return await tierFactFirstAPI.saveLaborFact(data);
};

export const getTimelineReasons = async (work_group_id, date_start = null, date_end = null) => {
  try {
    if (!work_group_id) {
      return [];
    }
    const res = await tierFactFirstAPI.getTimelineReasons(work_group_id, date_start, date_end);
    return res?.data || [];
  } catch (e) {
    console.error('Error loading timeline reasons:', e);
    return [];
  }
};